import React from "react";

import "./StepTitle.css";

const StepTitle = (props) => {
  const customClass =
    props?.className && props.className.length > 0 ? ` ${props.className}` : "";
  const className = `dialog-step-title${customClass}`;

  return (
    <div className={className}>
      <span>{props?.title}</span>
    </div>
  );
};

export default StepTitle;
